import React from "react";
import TurnMobile from "../../assets/rotate-smartphone.svg";

export default function MobileView() {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "10%",
        background: "#202020",
        width: "100%",
        height: "100%",
        top: "0px",
        left: "0px",
        position: "fixed",
        zIndex: "1000",
      }}
    >
      <img src={TurnMobile} />
      <h1 style={{ fontWeight: "bold", marginTop: "20vh" }}>
        Please turn your device
      </h1>
    </div>
  );
}
